import Entity from "./entity";
import Address from "./address";

export default class Tenant extends Entity<number> {
  tenancyName: string;
  name: string;
  isActive: boolean;
  adminEmailAddress: string;
  connectionString: string;
  contactPhone: string;
  provinceId: number;
  districtId: number;
  wardId: number;
  addressNo: string;
  fullAddress: string;
  inboundMode: string;
  contactAddressId: number;
  contactAddress: Address = new Address();
  createNotificationConfigs: any[];
}
